import React, {useEffect, useState} from 'react';
import SearchBox from "../prefabricated/SearchBox";
import {useSelector} from "react-redux";
import {Link, NavLink} from "react-router-dom";

const SearchEntities = ({styleName=null, placeholder=''}) =>{

    const { search, loadingSearchValues, errorLoadingSearchValues, loadingCycleTarget, loadingCycleTargetsError, loadingCycles, loadingCyclesError, } = useSelector(({breachrisk})=>breachrisk);

    // const [input, setInput] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    // const searchTechTypes = searchEntities && searchEntities.techType;

    const handleChange = (e) =>{

        setSearchText(e.target.value)
        console.log("This is updating the input", e.target.value)
    }

    const handleSearch = ()=>{
        console.log("This is what will be sent", searchText)
    }

    const showSearchOptions = () =>{
        // clear routes result if the routes field is empty
        if (searchText === "") {
            setSearchResults([]);
        }

        // discontinue if there is no routes yet
        if (searchText === null || searchText === "") return;

        // empty the previous routes array if any
        setSearchResults([]);
        let results = [];

        // create a regular expression pattern for the routes string
        const pattern = new RegExp(searchText, "gi");

        for (const key in search) {
            const type = search[key].type;

            // check if the routes word or character matches
            if (pattern.test(key)) {
                results.push(search[key]);
                console.log("found something in routes", search[key], "results", results)

            }
            setSearchResults(results)
        }
        console.log("update in routes text", search[pattern], "what is pattern", pattern,)

    }

    useEffect(()=>{
        showSearchOptions()
    }, [searchText])

    console.log("searchResults are", searchResults, "window.locaiton", window.location, "window.locaiton.routes", window.location.search)

    return(
        <div className="app-main-menu d-none d-md-block">
            <ul className="navbar-nav navbar-nav-mega">
                <li className={"nav-item"}>
                    <div className={`search-bar right-side-icon bg-transparent ${styleName} d-flex app-toolbar align-items-center`}>
                        <div className="form-group">
                            <input className="form-control border-0" type="search" placeholder={placeholder} onChange={handleChange}
                                   value={searchText}/>
                            <button onClick={handleSearch} className="search-icon"><i className="zmdi zmdi-search zmdi-hc-lg"/></button>
                        </div>
                    </div>

                    {searchResults &&
                        <ul className={"sub-menu"}>
                            {searchResults.map((result)=>
                                    <li className="">
                                        <NavLink className={"nav-menu-link"} to={`/board/search?type=${result.type}&name=${result.name}`}>
                                <span className={"nav-text"}>
                                {result.name} in {result.type}
                            </span>
                                        </NavLink>

                                    </li>
                            )}
                        </ul>
                    }
                </li>
            </ul>
        </div>
    )
}

export default SearchEntities;